import React from 'react';
import { MapPin, Clock, Ticket, Calendar, Plane, Hotel } from 'lucide-react';
import { Show } from '../types';
import { formatDate, formatTime } from '../utils/dateUtils';

interface ShowDetailsProps {
  show: Show;
}

const ShowDetails: React.FC<ShowDetailsProps> = ({ show }) => {
  return (
    <div 
      id={`show-${show.id}`} 
      className="mb-16 scroll-mt-24 opacity-0 animate-fadeIn"
    >
      <div className="bg-gray-900 rounded-lg overflow-hidden border border-red-800">
        <div className="relative h-64 md:h-80">
{show.image && (
  <img 
    src={show.image} 
    className="w-full h-full object-cover" 
    alt="Event" 
  />
)}
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent"></div>
          <div className="absolute bottom-0 left-0 p-6">
            <div className="flex items-center text-red-500 mb-2">
              <Calendar size={20} className="mr-2" />
              {formatDate(show.date)}
            </div>
            <h3 className="text-3xl font-bold mb-1">{show.city}</h3>
            <div className="flex items-center text-xl">
              <MapPin size={20} className="mr-2 text-red-500" />
              {show.venue}
            </div>
          </div>
        </div>
        
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <div className="space-y-4 text-gray-300">
                <div className="flex items-center">
                  <Clock size={20} className="mr-3 text-red-500 flex-shrink-0" />
                  <span>Doors: {formatTime(show.time)}</span>
                </div>
                <div className="flex items-center">
                  <Ticket size={20} className="mr-3 text-red-500 flex-shrink-0" />
                  <span>{show.ticketInfo}</span>
                </div>
                {show.schedule && (
                  <div className="text-sm bg-gray-800 p-4 rounded-lg border border-red-800">
                    <h4 className="font-bold mb-2 text-red-500">Show Schedule</h4>
                    <p>{show.schedule}</p>
                  </div>
                )}
              </div>
            </div>
            
            <div className="flex items-center justify-center md:justify-end">
             
            </div>
          </div>
          
          {(show.flightInfo || show.hotelInfo) && (
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
              {show.flightInfo && (
                <div className="bg-gray-800 p-4 rounded-lg border border-red-800">
                  <h4 className="font-bold mb-3 flex items-center text-red-500">
                    <Plane size={20} className="mr-2" />
                    Flight Information
                  </h4>
                  {show.flightInfo.arrival && (
                    <p className="text-sm mb-2">
                      <span className="font-semibold">Arrival:</span> {show.flightInfo.arrival}
                    </p>
                  )}
                  {show.flightInfo.departure && (
                    <p className="text-sm">
                      <span className="font-semibold">Departure:</span> {show.flightInfo.departure}
                    </p>
                  )}
                </div>
              )}
              
              {show.hotelInfo && (
                <div className="bg-gray-800 p-4 rounded-lg border border-red-800">
                  <h4 className="font-bold mb-3 flex items-center text-red-500">
                    <Hotel size={20} className="mr-2" />
                    Hotel Information
                  </h4>
                  <div className="text-sm space-y-2">
                    <p className="font-semibold">{show.hotelInfo.name}</p>
                    <p>{show.hotelInfo.address}</p>
                    <p>Check-in: {show.hotelInfo.checkIn}</p>
                    <p>Check-out: {show.hotelInfo.checkOut}</p>
                    <p>{show.hotelInfo.rooms}</p>
                    {show.hotelInfo.notes && (
                      <p className="italic text-gray-400">{show.hotelInfo.notes}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          
          <div className="mt-6 pt-6 border-t border-red-800">
            <p className="text-gray-300">{show.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowDetails